<template>
    <div v-if="homepageContent" class="flex space-x-2">
        <button @click="modalOpen = true" :class="!homepageContent && 'border border-slate-600 rounded-xl px-3.5 py-3 transition hover:bg-gray-200'">
            <QrIcon :icon="homepageContent ? 'pen' : 'heading'" class="w-5"/>
        </button>

        <DeleteHomePageContent v-if="homepageContent" class="ml-auto" :content="homepageContent"/>
    </div>
    <div v-else class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50">
        <div class="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
            <QrIcon icon="heading" class="h-6 w-6 text-gray-600 group-hover:text-brand" aria-hidden="true" />
        </div>
        <div>
            <button @click="modalOpen = true" class="font-semibold text-gray-900">
                {{ trans('homepage.header') }}
                <span class="absolute inset-0" />
            </button>
            <p class="mt-1 text-gray-600" v-text="trans('homepage.header_desc')"/>
        </div>
    </div>

    <QrModal v-model="modalOpen" :title="trans('homepage.header')">
        <QrForm @submit.prevent="saveOrUpdate" class="space-y-4">
            <QrInput
                v-model="menuButtonName"
                :label="trans('homepage.menu_button_name')"
                trans="homepage.menu_button_name"
                :errors="validationErrors.menu_button_name"
            />
        </QrForm>

        <template #buttons>
            <QrButton
                :text="trans('button.save')"
                trans="button.save"
                @click="saveOrUpdate"
                :loading="loading"
                :recently-succeeded="recentlySucceeded"
                :recently-failed="recentlyFailed"
            />
        </template>
    </QrModal>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import QrModal from "@/components/application-ui/dialogs/QrModal.vue";
import QrForm from "@/components/application-ui/content/QrForm.vue";
import QrInput from "@/components/application-ui/form/QrInput.vue";
import {trans} from "@/libs/helper.js";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import { storeToRefs } from "pinia";
import { useQrCodeHomepageStore } from "@/store/qrCodeHomepage.js";
import { useQrCodesStore } from "@/store/qrCodes.js";
import { useStatesStore } from "@/store/states.js";
import DeleteHomePageContent from "@/components/qr-code/homepage/DeleteHomePageContent.vue";

const props = defineProps({
    homepageContent: Object,
});

const statesStore = useStatesStore();
const { loading, recentlySucceeded, recentlyFailed, validationErrors } = storeToRefs(statesStore)

const qrCodeStore = useQrCodesStore();
const { qrCode } = storeToRefs(qrCodeStore);

const homepageStore = useQrCodeHomepageStore();
const modalOpen = ref(false);
const menuButtonName = ref('');
const emit = defineEmits(['close']);

const saveOrUpdate = async () => {
    if (props.homepageContent) {
        await homepageStore.updateContent(props.homepageContent.id, {
            menu_button_name: menuButtonName.value,
            is_password_protected: false,
        });
    } else {
        await homepageStore.create({
            type: 'header',
            menu_button_name: menuButtonName.value,
            is_password_protected: false,
        });
    }

    if (Object.keys(validationErrors.value).length === 0) {
        modalOpen.value = false
    }
}

watch(modalOpen, () => {
    if (! modalOpen.value) {
        emit('close');
    }
});

onMounted(() => {
    if (props.homepageContent) {
        menuButtonName.value = props.homepageContent.menu_button_name;
    }
})
</script>
